import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./NavBar.module.css";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import Logo from "../Assets/Images/logosinFondo.png";

const NavBar = () => {
  const [navBarOpen, setNavBarOpen] = useState(false);
  const [windowDimension, setWindowDimension] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const detectDimension = () => {
      setWindowDimension({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", detectDimension);
    windowDimension.width > 950 && setNavBarOpen(false);

    return () => {
      window.removeEventListener("resize", detectDimension);
    };
  }, [windowDimension]);

  const links = [
    { id: 1, link: "inicio", label: "Inicio" },
    { id: 2, link: "servicios", label: "Servicios" },
    // { id: 3, link: "proceso", label: "Proceso" },
    { id: 3, link: "testimonios", label: "Experiencias" },
    { id: 4, link: "contacto", label: "Contacto" }
  ];

  return (
    <div className={styles.navBar}>
      <div className={styles.containerLogo}>
        <Link to="/inicio" className={styles.logoLink}>
          <div className={styles.containerImage}>
            <img src={Logo} className={styles.imagenLogo} alt="logo" />
          </div>
          <p className={styles.logo}>BonFer Tech</p>
        </Link>
      </div>

      {windowDimension.width < 950 && (
        <>
          <div>
            {!navBarOpen ? (
              <IoMdMenu
                color="#f1f1f1"
                onClick={() => setNavBarOpen(true)}
                size={30}
                className={styles.menuIcon}
              />
            ) : (
              <IoMdClose
                color="#f1f1f1"
                onClick={() => setNavBarOpen(false)}
                size={30}
                className={styles.closeIcon}
              />
            )}
          </div>

          {navBarOpen && (
            <div className={styles.menuContent}>
              <ul className={styles.linksContainerOpen}>
                {links.map((x) => (
                  <li key={x.id} className={styles.menuItem}>
                    <Link
                      onClick={() => setNavBarOpen(false)}
                      to={`/${x.link}`}
                      className={styles.navLinkSmall}
                    >
                      {x.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}

      {windowDimension.width >= 950 && (
        <ul className={styles.linksContainer}>
          {links.map((x) => (
            <li key={x.id} className={styles.menuItem}>
              <Link
                onClick={() => setNavBarOpen(false)}
                to={`/${x.link}`}
                className={styles.navLink}
              >
                {x.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;
